import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class ManagementDataService {
  constructor(private common: CommonService) {}

  /**
   * 管理者获取全部猎头数据
   */
  async getHeadhuntingAll(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingTool/getHeadhuntingAll',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 管理者获取全部猎头数据 树形数据
   */
  async getJobTree(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingTool/getJobTree',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取全部招聘的部门信息 树形数据
   */
  async getDepartTree(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingTool/getDepartTree',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取邀约数据今日总计列表
   */
  async getTodayCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingManagerData/getTodayCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取邀约数据今日列表
   */
  async getTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingManagerData/getTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取邀约数据总计列表
   */
  async getAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingManagerData/getAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取邀约数据列表
   */
  async getList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'headhuntingManagerData/getList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 根据部门id获取当前部门正在招聘的岗位
   */
  async getJobList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingTool/getJobListByDepartId',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取今日的总计数据
   */
  async getInterviewTodayCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInviteManager/getTodayCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取今日的列表数据
   */
  async getInterviewTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInviteManager/getTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 面试总计数据
   */
  async getInterviewAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInviteManager/getAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取指定日期的面试列表数据
   */
  async getInterviewList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInviteManager/getList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取邀约猎头今日初复试不通过 总计
   */
  async getHeadhuntingNoPassTodayCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoPassTodayCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取邀约猎头今日初复试不通过列表
   */
  async getHeadhuntingNoPassTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoPassTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取邀约猎头初复试不通过 总计
   */
  async getHeadhuntingNoPassAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoPassAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取邀约猎头初复试不通过列表
   */
  async getHeadhuntingNoPassList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoPassList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取猎头面试今日拒绝总计
   */
  async getHeadhuntingNoAcceptTodayCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoAcceptTodayCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取猎头面试今日拒绝列表
   */
  async getHeadhuntingNoAcceptTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoAcceptTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取猎头面试拒绝总计
   */
  async getHeadhuntingNoAcceptAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoAcceptAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取邀约猎头初复试拒绝列表
   */
  async getHeadhuntingNoAcceptList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoAcceptList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官面试今日不通过总计
   */
  async getInterviewerNoPassTodayCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/InterviewerStatistics/getNoPassTodayCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官面试今日不通过列表
   */
  async getInterviewerNoPassTodayList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/InterviewerStatistics/getNoPassTodayList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官面试不通过总计
   */
  async getInterviewerNoPassAllCount(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/InterviewerStatistics/getNoPassAllCount',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官面试不通过列表
   */
  async getInterviewerNoPassList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/InterviewerStatistics/getNoPassList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取详细应聘者列表 面试官不通过
   */
  async getInterviewerUserList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/InterviewerStatistics/getUserList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取详细应聘者列表 猎头不通过
   */
  async getHeadhuntingUserList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getUserList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取详细应聘者列表 猎头拒绝
   */
  async getHeadhuntingNoAcceptUserList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingStatistics/getNoAcceptUserList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }

  /**
   * 获取【面试不通过或面试拒绝】标签列表
   */
  async getLabel(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/Statistics/getLabel',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 管理者获取全部面试官数据
   */
  async getInterviewerAll(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/headhuntingTool/getInterviewerAll',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 根据邀约者id或面试官id获取员工的具体信息
   */
  async getEmployee(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'V2/Statistics/getEmployee',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
  /**
   * 获取面试官面试的应聘者详情列表
   */
  async getUserList(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.common.ajax({
        url: 'interviewInviteManager/getUserList',
        type: 'get',
        data,
        loading: true,
        success: (res) => {
          resolve(res);
        },
        fail: (res) => {
          reject(res);
        },
      });
    });
  }
}
